import TtamBehaviorCreatorActions from './behavior-creator-actions/index.vue';
import TtamBehaviorCreatorCategory from './behavior-creator-category/index.vue';
import { useContainerProps } from './hooks';

export default {
  TtamBehaviorCreatorActions,
  TtamBehaviorCreatorCategory,
  useContainerProps,
};
